export function filterActiveScans(scans, skippedScanIds) {
  const skipped = skippedScanIds instanceof Set ? skippedScanIds : new Set(skippedScanIds || []);
  return (scans || []).filter((scan) => !skipped.has(scan.id));
}

export function skipScanInRound(scans, skippedScanIds, scanId) {
  const nextSkippedScanIds = new Set(skippedScanIds || []);
  if (scanId) nextSkippedScanIds.add(scanId);

  return {
    skippedScanIds: nextSkippedScanIds,
    roundComplete: (scans || []).length > 0
      && (scans || []).every((scan) => nextSkippedScanIds.has(scan.id)),
  };
}

export function getNextScanAfterRemoval(scans, currentScanId, removedScanIds) {
  const list = scans || [];
  const removed = removedScanIds instanceof Set ? removedScanIds : new Set(removedScanIds || []);
  const currentIndex = list.findIndex((scan) => scan.id === currentScanId);
  const startIndex = currentIndex >= 0 ? currentIndex : 0;

  for (let index = startIndex + 1; index < list.length; index += 1) {
    if (!removed.has(list[index].id)) return list[index].id;
  }
  for (let index = startIndex - 1; index >= 0; index -= 1) {
    if (!removed.has(list[index].id)) return list[index].id;
  }
  return null;
}
